// Takes an array and chunk size and converts the array into chunks of given size.
export function chunkArrayInGroups<T>(arr: T[], size: number): T[][] {
  const myArray = [];
  for (let i = 0; i < arr.length; i += size) {
    const chunk = arr.slice(i, i + size);
    if (chunk.length > 0) {
      myArray.push(chunk);
    }
  }
  return myArray;
}

// A function to compare if two arrays have the same elements regardless of their order
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const runDeepEquals = (a: any, b: any): boolean => {
  // If they point to the same instance of the array
  if (a === b) return true;

  // If they point to the same instance of date
  if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();

  // If both of them are not null and their type is not an object
  if (!a || !b || (typeof a !== 'object' && typeof b !== 'object')) {
    return a === b;
  }

  // Check if both of the objects have the same number of keys
  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) {
    return false;
  }

  // Check recursively for every key in both
  return keys.every((k) => runDeepEquals(a[k], b[k]));
};

export const deepEquals = <T>(a: Array<T> | undefined | null | T, b: Array<T> | undefined | null | T): boolean => {
  return runDeepEquals(a, b);
};

function stringIsNumber(value: string): boolean {
  return Number.isNaN(Number(value));
}

export function EnumToArrayValues(enumeration: { [x: string]: any }) {
  return Object.keys(enumeration)
    .filter(stringIsNumber)
    .map((key) => enumeration[key]);
}

export function enumCount(enumeration: { [x: string]: any }) {
  return Object.keys(enumeration).filter(stringIsNumber).length;
}

export function getLastObject<T>(array: T[]): T | undefined {
  if (array.length === 0) {
    return undefined;
  }
  return array[array.length - 1];
}

export function generateNumbersArray(start: number, end: number, step: number): number[] {
  const bandSizes: number[] = [];
  for (let index = start; index <= end; index += step) {
    bandSizes.push(index);
  }
  return bandSizes;
}

export const intersects = <T>(a: T[], b: T[]) => {
  const set = new Set(a);
  const firstValue = b.find((v) => set.has(v));
  return !!firstValue;
};

export const findAddedAndRemovedElements = <T>(before: T[], after: T[]): { added: T[]; removed: T[] } => {
  const added: T[] = [];
  const removed: T[] = [];

  const beforeSet = new Set(before);
  const afterSet = new Set(after);

  // Find added elements
  for (const item of after) {
    if (!beforeSet.has(item)) {
      added.push(item);
    }
  }

  // Find removed elements
  for (const item of before) {
    if (!afterSet.has(item)) {
      removed.push(item);
    }
  }

  return { added, removed };
};
